import { render, staticRenderFns } from "./ParameterRouterAuthContainer.vue?vue&type=template&id=671f63ae&scoped=true"
import script from "./ParameterRouterAuthContainer.vue?vue&type=script&lang=js"
export * from "./ParameterRouterAuthContainer.vue?vue&type=script&lang=js"
import style0 from "./ParameterRouterAuthContainer.vue?vue&type=style&index=0&id=671f63ae&prod&lang=scss&scoped=true"
import style1 from "./ParameterRouterAuthContainer.vue?vue&type=style&index=1&id=671f63ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f63ae",
  null
  
)

export default component.exports